enum EmployeeModalWindowTitle {
  EmployeeAddFormTitle = 'Add Employee'
}

export default EmployeeModalWindowTitle;
